(function() {
    'use strict';
    angular.module('wbDashboard').factory('DataService', ['$q', '$filter', 'Request', 'Track', function ($q, $filter, Request, Track) {
        var data = {},

            dataData = {
                'assetClasses' : null,
            },
            promises = {
            };

        /**
         * Returns entire dataData object
         */
        data.getDataData = function() {
            return data.get();
        };

        /**
         * Get specific dataData key
         * @param type
         * @returns {*}
         */
        data.get = function (type) {
            if (!type) {
                return dataData;
            } else {
                return dataData[type];
            }
        };
        /**
         * Clear any dataData key or entire object
         * @param type
         * @returns {boolean}
         */
        data.clear = function (type) {
            if (type) {
                if (!(type in dataData)) {
                    throw new Error("DataService: Invalid type in dataData");
                }
                dataData[type] = null;
            } else {
                Object.keys(dataData).forEach(function(key) {
                    dataData[key] = null;
                });
            }
            return true;
        };
        /**
         * Manually update any particular data in any dataData key
         * @param type
         * @param data
         */
        data.manualSet = function(type, data) {
            if (!(type in dataData)) {
                throw new Error("DataService: Invalid type in dataData");
            }
            dataData[type] = dataData[type] || {};
            dataData[type] = angular.extend(dataData[type], data);
        };


        /**
         * Get all data data that's already been retrieved
         * @returns {*}
         */
        data.getAssetClasses = function (code) {
            var assetClasses = data.get('assetClasses');
            if (code && assetClasses) {
                var returnAsset = null;
                angular.forEach(assetClasses, function(a) {
                    if (a.code === code) {
                        returnAsset = a;
                    }
                });
                return returnAsset;
            } else {
                return assetClasses;
            }
        };
        data.getAssetClass = function (code) {
            if (!code) return null;
            return data.getAssetClasses(code);
        };
        /**
         * Request all asset class assetClasses data from server
         * @returns {*}
         */
        data.retrieveAssetClasses = function (refresh) {
            if (data.getAssetClasses() && !refresh) {
                return $q.when(data.getAssetClasses());
            } else {
                return Request.make('asset_classes').then(function (response) {
                    dataData.assetClasses = response.data.response;
                    return dataData.assetClasses;
                });
            }
        };

        data.info = {};

        return data;
    }]);
})();
